import { Query } from 'react-apollo'
import myDebts, { MyDebts, IFragmentBasicLoanFields } from '../../graphql/queries/myDebts'
import withQuery from './withQuery'
import { GetProps } from '../../types'

class MyDebtsQuery extends Query<MyDebts, {}> {}

const MyDebtsQueryCompleted = withQuery(myDebts)(MyDebtsQuery)

export type MyDebtsQueryProps = GetProps<typeof MyDebtsQueryCompleted>
export type MyDebtsQueryResult = MyDebts
export type Loan = IFragmentBasicLoanFields

export default MyDebtsQueryCompleted



// WEBPACK FOOTER //
// ./src/components/queries/MyDebtsQuery.tsx